import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './themes/theme';
import { GlobalStateProvider } from './context/globalStateProvider';
import Main from './pages/main';
import './App.css';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStateProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Navigate to="/:id" replace />} />
            <Route path="/:id" element={<Main />} />
          </Routes>
        </Router>
      </GlobalStateProvider>
    </ThemeProvider>
  );
}

export default App;
